import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    document.title = "页面未找到 | 国产精品久久";
  }, []);

  return (
    <div className="mx-auto flex min-h-[70vh] w-full flex-col items-center justify-center px-4 py-20 text-center md:px-8">
      <span className="font-heading text-7xl font-bold text-primary-500 md:text-9xl">404</span>
      <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        这个页面走丢了
      </h1>
      <p className="mt-3 text-sm text-foreground-600">
        你访问的页面不存在或已被移除
      </p>
      <p className="mt-1 break-all font-mono text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category/all"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-compass-3-line" />
          浏览全部影视
        </Link>
      </div>
    </div>
  );
}